import {showError} from "./exceptionUtils";
import { playScanFailedAoSound } from "./scanUtils";
import { t } from '../i18n';

const BAG_NUMBER_PREFIX = 'BAG';
const TT_BAG_NUMBER_PREFIX = 'TT';
const TRACKING_NUMBER_PREFIX = 'SWX';

const BAG_NUMBER_LENGTH = 16;
const TRACKING_NUMBER_LENGTH = 21;
const TT_BAG_NUMBER_LENGTH = 20;

export const isBagNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    return barCode.startsWith(BAG_NUMBER_PREFIX) && barCode.length === BAG_NUMBER_LENGTH;
};

/**
 * TT 包牌：以 TT 开头（如 TTLAX1ATL…），或 20 位且非 BAG 前缀（不带 BAG 的 TT 号格式）。
 */
export const isTtBagNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    const trimmed = barCode.trim();
    if (trimmed.toUpperCase().startsWith(TT_BAG_NUMBER_PREFIX)) {
        return true;
    }
    return !trimmed.startsWith(BAG_NUMBER_PREFIX) && trimmed.length === TT_BAG_NUMBER_LENGTH;
};

export const isTrackingNumber = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    if(barCode.startsWith(TRACKING_NUMBER_PREFIX))
        return barCode.length === TRACKING_NUMBER_LENGTH;
    else 
        return true;
};

export const isValidBarCode = (barCode: string) => {
    if (!barCode) {
        return false;
    }
    if(barCode.startsWith(BAG_NUMBER_PREFIX))
        return isBagNumber(barCode);
    else 
        return isTrackingNumber(barCode);
};

export const showBarCodeError = async (barCode: string) => {
    if (barCode.length === 0) {
        return;
    }
    await playScanFailedAoSound();
    showError({
        title: t('pda.errors.invalidBarCode.title'),
        message: t('pda.errors.invalidBarCode.message', { barCode }),
    });
};

export const showTrackingNumberError = async (barCode: string) => {
    if (barCode.length === 0) {
        return;
    }
    await playScanFailedAoSound();
    showError({
        title: t('pda.errors.invalidTrackingNumber.title'),
        message: t('pda.errors.invalidTrackingNumber.message', { barCode }),
    });
};

export const showBagNumberError = async (barCode: string) => {
    if (barCode.length === 0) {
        return;
    }
    await playScanFailedAoSound();
    showError({
        title: t('pda.errors.invalidBagNumber.title'),
        message: t('pda.errors.invalidBagNumber.message', { barCode }),
    });
};